import React from 'react';
import AppBaseComponent from '../../../components/AppBaseComponent';
import ApplicationLayout from "../../../layouts/ApplicationLayout";
import { connect } from "react-redux";
import Ax from "../../../components/hoc/Ax";
import moment from "moment";
import tapIcon from "../../../services/TapIcon";
import HttpAPICall from "../../../services/HttpAPICall";
import TapApiUrls, { INVENTORY_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import Loader from "../../../components/ui/Loader/Loader";
import { Collapse, Modal } from 'bootstrap';
import {DisplayListPagination, DisplaySearchCriteria, PeriodSelectionWithCustom} from "../../../components/TapUi/index";
import {Link} from "react-router-dom";
import DownloadFile from "../../../services/DownloadFile";
import InputItemSearch from '../../includes/ui/InputItemSearch';
import TapSelect from "../../../components/ui/TapSelect";
import { Helmet } from 'react-helmet';
import swal from "sweetalert";
import Status from '../../../components/ui/Status';
import InventoryTransferDetail from '../../inventory/inventoryTransfer/InventoryTransferDetail';

class ItemWiseInventoryTransfer extends AppBaseComponent {
    
    constructor(props) {
        super(props);
        
        this.reportFilterFormInitialState   =   {
            search_transaction_id               :   '',
            search_warehouse_from_ids           :   [],
            search_warehouse_to_ids           :   [],
            date_range                          :   null,
            date_range_start                    :   null,
            date_range_end                      :   null,
            search_item_ids                     :   [],
            search_item_tags                    :   [],
            search_status_ids                   :   [],
            search_manufacturer_ids             :   [],
            search_indent_transaction_id        :   ''
        };
        
        this.reportFilterFormLabel          =   {
            search_transaction_id             :       'Transaction ID : ',
            search_warehouse_from_ids       :       'Dispatching Warehouse : ',
            search_warehouse_to_ids         :       'Receiving Warehouse : ',
            date_range                        :       'Date Range : ',
            search_item_ids                   :       'Items : ',
            search_item_tags                  :        'Item Tags : ',
            search_status_ids                 :        'Search Status : ',
            search_priority                   :        'Search Priority : ',
            search_manufacturer_ids           :        'Manufacturer : ',
            search_indent_transaction_id      :        'Indent : ',
        };
        
        
        this.state                          =   {
            formDataLoaded                      :   false,
            reportDownloadBtn                   :   false,
            reportDownloading                   :   false,
            all_warehouses                      :   [],
            reportFilterForm                    :   {...this.reportFilterFormInitialState},
            submittedReportFilterForm           :   {...this.reportFilterFormInitialState},
            listing_loading                     :   false,
            searchedItem                        :   [],
            listingData                         :   [],
            listingMeta                         :   null, 
            allStatusOptions                    :   [],
            allItemTags                         :   [],
            iam_manufactures                    :    [],
            searchedAssets                      :    [],
            transactionId                       :    '',
            allDispatchingWarehouses            :   [],
            allReceivingWarehouses              :   [],
            download_access                     :   false,     
            reportData                          :   null,
            criteriaHeight                      :   0                      

        };
        this.criteriaRef                        =   React.createRef();
        this.reportUrl              =   INVENTORY_API_BASE_URL_2 + '/report/item-wise-inventory-tranfer';
        this.reportFormDataUrl      =   INVENTORY_API_BASE_URL_2 + '/inventory_transfer/add_form_data';
    }
    
    componentDidMount(){
        this.initilaizeAppDataToFilterForm(this.props);
        this.viewTransactionModal              =     new Modal(document.getElementById('viewTransactionModal'), {keyboard: false, backdrop :false});
  }
    updateCriteriaHeight = () => {
        if (this.criteriaRef.current) {
            const height = this.criteriaRef.current.offsetHeight;
            if (this.state.criteriaHeight !== height) {
                this.setState({ criteriaHeight: height });
            }
        }
    }; 
      componentDidUpdate(prevProps, prevState) {
        if (prevState.formSearchedElems !== this.state.formSearchedElems) {
            this.updateCriteriaHeight();
        }
    }
    componentWillReceiveProps(nextProps){
        if(nextProps.all_warehouses !== this.props.all_warehouses || nextProps.all_periods !== this.props.all_periods) {
            this.initilaizeAppDataToFilterForm(nextProps);
        }
    }

    initilaizeAppDataToFilterForm           =   (props)  =>  {

        const report_name   =   props?.location?.pathname ? props.location.pathname.split('/')[2] : '';
        const reportData    =   props?.report_listing.length > 0 ? props.report_listing.filter(d => d.key === report_name) : [];

        let all_periods                     =         [...props.all_periods , {key : 'custom' , display : 'Custom Date Range'}] ;
        
        HttpAPICall.withAthorization('GET', this.reportFormDataUrl, props.access_token, null, null, (response) => {
            this.setState({
                reportData                  :   reportData.length > 0 ? reportData[0] : null,
                download_access             :   reportData.length > 0  && reportData[0].download_access === 'Y' ? true  : false,
                reportFilterFormData        :   {...response.data},
                allDispatchingWarehouses          :    props.all_warehouses ? props.all_warehouses.map((s) => { return { value: s.id, label: s.name, site_id: s.site_id }; }) : [],
                allReceivingWarehouses            :    props.all_warehouses ? props.all_warehouses.map((s) => { return { value: s.id, label: s.name, site_id: s.site_id }; }) : [],
                formDataLoaded              :   true,
                all_periods                 :   all_periods ,
                iam_manufactures            :   response.data && response.data.manufacturers && response.data.manufacturers.length > 0  ? response.data.manufacturers.map((m) => { return {value: m.id, label: m.name}}) : [],
                allStatusOptions            :   response.data && response.data.status && response.data.status.length > 0 ?  response.data.status.map((s) => { return {value: s.key, label: s.status}; }) : [],
                allItemTags                 :   props.item_tags && props.item_tags.length > 0 ? props.item_tags.map((s) => { return {value: s.id, label: s.name}; }) : [],
          
            }, () => {
                this.reportFilterFormSubmit()
            // let status_ids               =    [];
            // let updateFilterForm        =       {};
            // let ParamObject                 =       new URLSearchParams(props.location.search);
          
            // if(ParamObject.get('search_status_ids') ||  ParamObject.get('search_item_ids')){
            //     if(ParamObject.get('search_status_ids')){
            //         status_ids  =  ParamObject.get('search_status_ids').split(',').map(Number); 
            //         if (ParamObject.get('search_warehouse_ids')) {
            //             let warehouse =  this.state.all_warehouses.find(us => us.value == ParamObject.get('search_warehouse_ids'));
            //             if (warehouse) {
            //                 updateFilterForm['search_warehouse_ids'] = [warehouse.value];
            //             }
            //         }
            //     }

            //     if (ParamObject.get('search_item_ids')) {    
            //         updateFilterForm['search_item_ids'] = [ParamObject.get('search_item_ids')];   
            //     }
                
            
            // }else if (ParamObject.get('asset_id')) {

            //   updateFilterForm        =            { date_range: "current_year", search_asset_ids: [ParamObject.get('asset_id')] };

            // } else{
            //     status_ids  =  this.state.allStatusOptions.filter(s => s.level <= 4).map(s => s.value) 
            // }
            
            // setTimeout(() => {
            //     this.setState({
            //         reportFilterForm        :   {...this.state.reportFilterForm,search_status_ids : status_ids,...updateFilterForm},
            //         searchedAssets          :    ParamObject.get('asset_id') ? [{
            //                                                             value               :        ParamObject.get('asset_id'),
            //                                                             display_label       :       `${ParamObject.get('asset_name')} (${ParamObject.get('asset_code')})`
            //                                                         }] : [],
            //          searchedItem            :  ParamObject.get('search_item_ids') ?  [{value : ParamObject.get('search_item_ids'), display_label :  `${ParamObject.get('item_name')}` }] : []
            //     },() => {
            //         this.reportFilterFormSubmit()
            //     })
            // },1000)

            } );
        }, (err) => {

        });
    }
    
    reportFilterFormSubmit                  =   (event=null)  =>  {
        event && event.preventDefault();
        event && this.reportFilterhandler(true);
        
        let serachFormKeys                  =   Object.keys(this.state.reportFilterForm);
        let searchedElems                   =   [];
        let itemSearchParams                =   {};
        serachFormKeys.map((key)        =>  {
            let label                       =   this.reportFilterFormLabel[key];
            let value                       =   this.state.reportFilterForm[key];
            if(value && value.toString().length > 0) {
                itemSearchParams[key]      =   value;
                if(label) {
                    let show_val            =   value;
                if(key == 'search_transaction_id') {
                    show_val            =   this.state.reportFilterForm ? this.state.reportFilterForm.search_transaction_id : '';
                }
                if(key == 'search_indent_transaction_id') {
                    show_val            =   this.state.reportFilterForm ? this.state.reportFilterForm.search_indent_transaction_id : '';
                }
               
                if(key == 'search_warehouse_from_ids') {
                    show_val            =   this.state.allDispatchingWarehouses.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
               }
               if(key == 'search_warehouse_to_ids') {
                    show_val            =   this.state.allReceivingWarehouses.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
               }
                if(key == 'search_item_ids') {
                    show_val            =   this.state.searchedItem ? this.state.searchedItem.map(s => s.display_label).join(', ') : '';
                }
                if(key == 'search_item_tags') {
                    show_val            =   this.state.allItemTags.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                }
                if(key == 'search_status_ids') {
                    show_val            =   this.state.allStatusOptions.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                }
                if(key == 'search_priority') {
                    show_val            =   this.state.allPriorityOptions.filter((s) => value.includes(s.value)).map(s => s.label);
                }
                if(key == 'search_manufacturer_ids') {
                    show_val            = this.state.iam_manufactures.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                }
                
                if(key == 'date_range') {
                    let  start_range         =      moment(this.state.reportFilterForm.date_range_start).format('DD-MMM-YYYY');
                    let end_range            =      moment(this.state.reportFilterForm.date_range_end).format('DD-MMM-YYYY')
                        let display_custom      =      `Custom Date Range (${start_range} - ${end_range})`
                        show_val                 =     this.state.all_periods.filter((s) => value.includes(s.key)).map(s => s.display_with_date ? s.display_with_date : display_custom);
                    }
                    searchedElems.push(label + `<b>${show_val}</b>`);
                }
            }
        });
        this.setState({
            submittedReportFilterForm           :   {...this.state.reportFilterForm},
            formSearchedElems                   :   searchedElems
        }, () => {
             this.loadListingTblData(1);
        });
    }
    
    loadListingTblData                      =   (page=1) => {
        this.setState({
            listing_loading             :   true,
            listingData                 :   [],
            listingMeta                 :   null,
            reportDownloadBtn           :   false,
            reportDownloading           :   false
        });
        let params                          =   {page:page, ...this.state.submittedReportFilterForm,action:"data"};
        HttpAPICall.withAthorization('GET', this.reportUrl, this.props.access_token, params, {}, (response) => {
            let respData                =   response.data;
            this.setState({
                listingData                 :   respData.data,
                reportDownloadBtn           :   true,
                listingMeta                 :   {
                    from                        :   respData.from,
                    to                          :   respData.to,
                    total                       :   respData.total,
                    last_page                   :   respData.last_page,
                    per_page                    :   respData.per_page,
                    current_page                :   respData.current_page
                }
            });
        }, (err) => {}).then(() => {
            this.setState({listing_loading: false});
        });
    }
    
    reportDownloadHandler                   =   ()  =>  {
        let formData                            =   {...this.state.submittedReportFilterForm};
        if(formData.search_transaction_id != '' || formData.date_range != '') {
            this.reportDownloadApiCall(formData);
        } else if((JSON.stringify(formData) === JSON.stringify(this.reportFilterFormInitialState)) || formData.date_range == '') {
            swal({ 
                title: "Download", icon: "warning", buttons: ["Cancel", "Okay"],
                text: "The download will be for Current Quarter, in case you want a different Period then apply the criteria before downloading.",
            }).then(willDownload => {
                if (willDownload) { this.reportDownloadApiCall({...formData, date_range: "current_quarter"}); }
            });
        }
    }
    
    reportDownloadApiCall                   =   (formData)  =>  {
        this.setState({ reportDownloading: true});
        HttpAPICall.withAthorization('GET', this.reportUrl, this.props.access_token, {...formData, action : 'download'} , {} , (response) => DownloadFile.file(null,response.data.msg,response.data.navigation,this.props)).then(() => this.setState({reportDownloading: false}));
    }
    
    
    reportFilterhandler                     =   (collapse = true)  =>  {
        collapse && new Collapse(document.getElementById('reportFilterForm'));
        if(document.getElementById('pageTbl')) {
            document.getElementById('pageTbl').scroll({ top: 0, behavior: 'smooth' });
        }
    }

    closeReport                             =       ()      =>  {
        this.props.history.goBack()
    }
    
    viewTransferDetailInit          =       (id)        =>      {
        this.setState({
            transactionId       :   id
        })
        this.viewTransactionModal.show();
    }

    pageTitleBarJsx                         =   ()  =>  {
        return (<div className="page_title row m0">
            <div className="col-sm-12">
                <h3><tapIcon.FontAwesomeIcon icon={tapIcon.faCubes} /> {this.state.reportData?.name}</h3>
                <div className="text-end mt15">
                    <button type="button" onClick={this.reportFilterhandler} className="btn btn-secondary">Change Filter</button>
                    <button type="button" id='actionMenuButton' data-bs-toggle="dropdown" aria-expanded="false" className="btn btn-secondary">
                        <tapIcon.imageIcon icon={tapIcon.ActionIcon} className="img-fluid" alt="item-action" />
                        {this.state.reportDownloading ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin ms-2"/>) : null}
                    </button>
                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                        <li><Link className={['dropdown-item', !this.state.download_access ? 'disabled' : ''].join(' ')} onClick={this.reportDownloadHandler}>Download</Link></li>
                    </ul>
                    <button type="button" className="btn btn-secondary" onClick={this.closeReport}>
                        <tapIcon.imageIcon icon={tapIcon.CloseIcon} className="img-fluid" alt="item-close" />
                    </button>
                </div>
            </div>
        </div>);
    }
    
    reportFilterFormJsx = () => {
        return (<div id="reportFilterForm" className="bg-white collapse " >
            <form onSubmit={this.reportFilterFormSubmit} className={['p-3', 'filter_form'].join(' ')}>

                <div className="row my-3">
                    <label className="col-sm-3 col-form-label text-end">Item</label>
                    <div className="col-sm-6">
                        <InputItemSearch
                            isMulti={true}
                            changeEvent={(selectedOption) => {
                                this.tapSelectChange(selectedOption, 'reportFilterForm', 'search_item_ids');
                                this.setState({
                                    searchedItem: selectedOption ? selectedOption : []
                                }, () => { });
                            }}
                            value={this.state.searchedItem && this.state.searchedItem.length > 0 ? this.state.searchedItem.map(a => { a.label = a.display_label; return a; }) : []}
                        />
                    </div>
                </div>
                <div className="row my-3 align-items-center">
                    <label className="col-sm-3 col-form-label text-end">Item Tags</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={this.state.allItemTags}
                            changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'reportFilterForm', 'search_item_tags')}
                            value={this.state.allItemTags.filter(u => this.state.reportFilterForm?.search_item_tags?.includes(u.value))}
                            isSearchable={true}
                            isMulti={true}
                            isClearable={true}
                            placeholder="Select Item Tags"

                        />
                    </div>
                </div>
             
                <div className="row my-3 align-items-center">
                    <label className="col-sm-3 col-form-label text-end">Dispatching Warehouse</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={this.state.allDispatchingWarehouses}
                            changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'reportFilterForm', 'search_warehouse_from_ids')}
                            value={this.state.allDispatchingWarehouses.filter(u => this.state.reportFilterForm?.search_warehouse_from_ids?.includes(u.value))}
                            isSearchable={true}
                            isMulti={true}
                            isClearable={true}
                            placeholder="Select Dispatching Warehouses"
                        />
                    </div>
                </div>
                <div className="row my-3 align-items-center">
                    <label className="col-sm-3 col-form-label text-end">Receiving Warehouse</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={this.state.allReceivingWarehouses}
                            changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'reportFilterForm', 'search_warehouse_to_ids')}
                            value={this.state.allReceivingWarehouses.filter(u => this.state.reportFilterForm?.search_warehouse_to_ids?.includes(u.value))}
                            isSearchable={true}
                            isMulti={true}
                            isClearable={true}
                            placeholder="Select Receiving Warehouses"
                        />
                    </div>
                </div>
              
                <div className="row my-3 align-items-center">
                    <label className="col-sm-3 col-form-label text-end">Transaction ID</label>
                    <div className="col-sm-6">
                        <input
                            name="search_transaction_id"
                            type="text"
                            value={this.state.reportFilterForm.search_transaction_id}
                            className="form-control"
                            autoComplete="off"
                            onChange={(e) => this.formInputHandler(e, "reportFilterForm")}
                            placeholder="Please enter Transaction ID"

                        />
                    </div>
                </div>
                <div className="row my-3 align-items-center">
                    <label className="col-sm-3 col-form-label text-end">Indent Transaction ID</label>
                    <div className="col-sm-6">
                        <input
                            name="search_indent_transaction_id"
                            type="text"
                            value={this.state.reportFilterForm.search_indent_transaction_id}
                            className="form-control"
                            autoComplete="off"
                            onChange={(e) => this.formInputHandler(e, "reportFilterForm")}
                            placeholder="Please enter Indent Transaction ID"

                        />
                    </div>
                </div>
                <div className="row my-3 align-items-center">
                    <label className="col-sm-3 col-form-label text-end">Status</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={this.state.allStatusOptions}
                            changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'reportFilterForm', 'search_status_ids')}
                            isMulti={true}
                            isClearable={true}
                            value={this.state.allStatusOptions.filter(s => this.state.reportFilterForm.search_status_ids.includes(s.value))}
                            placeholder="Select Status"
                        />
                    </div>
                </div>
                
                <div className="row my-3">
                    <label className="col-sm-3 col-form-label text-end">Transaction Period</label>
                    <div className="col-sm-6">
                        <PeriodSelectionWithCustom
                            periods={this.state.all_periods ? this.state.all_periods : []}
                            value={this.state.reportFilterForm.date_range}
                            startDate={this.state.reportFilterForm.date_range_start}
                            endDate={this.state.reportFilterForm.date_range_end}
                            onSelectPeriod={(period, startDate, endDate) => {
                                this.setState({
                                    reportFilterForm
                                        : {
                                        ...this.state.reportFilterForm,
                                        date_range: period,
                                        date_range_start: startDate ? startDate : null,
                                        date_range_end: endDate ? endDate : null
                                    }
                                });
                            }}

                        />
                    </div>
                </div>
                <div className="row">
                    <div className="pb-3 col-9 text-end">
                        <button type="submit" disabled={this.state.listing_loading ? true : false} className="btn btn-primary px-4">Show Report</button>
                    </div>
                    <hr />
                </div>
            </form>
        </div>);
    }
    
    reportListingDisplayJsx                 =   ()  =>  {
        return (<div className="bg-white">
            { this.state.listing_loading
                ? <Loader />
                : (this.reportTableJsx())
            }
        </div>)
    }
    
    reportTableJsx                          =   ()  =>  {
        return (<Ax>

            <table className="table table-bordered  table-sm align-middle bg-white mt-2" id="reqTable">
                <thead className="align-middle table-secondary"  style={{
                    top: `${this.state.criteriaHeight}px`,
                    position: 'sticky',
                }}>
                    <tr>
                        <th className="text-center" style={{ width: "5%" }}>S.No</th>
                        <th style={{ width: "8%" }}>Transaction ID</th>
                        <th scope="col" className='text-center' style={{ width: "9%" }}>Transaction Date</th>
                        <th style={{ width: "12%" }}>Dispatching Warehouse</th>
                        <th style={{ width: "12%" }}>Receiving Warehouse</th>
                        <th style={{ width: "14%" }}>Item Name</th>
                        <th style={{ width: "14%" }}>Item Code</th>
                        <th scope="col" className='text-end' style={{ width: "6%" }}>Quantity</th>
                        <th scope="col" className='text-end' style={{ width: "6%" }}>Amount</th>
                        <th style={{ width: "8%" }} className='text-center'>Status</th>
                      
                    </tr>
                </thead>
                <tbody>
                    {this.state.listingData && this.state.listingData.length > 0
                        ? (this.state.listingData.map((rowData, k) => {
                            
                                return (<tr key={k}>
                                    <td className='text-center'>{this.state.listingMeta ? this.state.listingMeta.from + k : k }</td>
                                    <td><a hred="#" role="button" className='link-primary' onClick={() => this.viewTransferDetailInit(rowData.transaction_id)}>{rowData.transaction_id}</a></td>
                                    <td className='text-center'>{rowData.transaction_date_display}</td>
                                    <td>{rowData.warehouse_from ? rowData.warehouse_from.name : ""}</td>
                                    <td>{rowData.warehouse_to ? rowData.warehouse_to.name : ""}</td>
                                    <td>{rowData.item_name ? rowData.item_name : ""}</td>
                                    <td>{rowData.item_code ? rowData.item_code : ""}</td>
                                    <td className='text-end'>{rowData.qty ? rowData.qty : ""}</td>
                                    <td className='text-end'>{rowData.qty * rowData.rate}</td>
                                    <td className='text-center'><Status color={rowData.status_color}>{rowData.status_text}</Status></td>
                                </tr>);
                           // })
                        }))
                        : (<tr><td className="text-center" colSpan={10}>No Record Found</td></tr>)
                    }
                </tbody>
            </table>
        </Ax>);
    }

    transactionDetailsModalJsx                     =   ()  =>  {
        return (
            <div className="modal fade" id="viewTransactionModal" tabIndex="-1">
                <div className="modal-dialog modal-lg modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="searchItemModalLabel">Transaction Id : {this.state.transactionId ? this.state.transactionId : "-"}</h5>
                            <button type = "button" className="btn btn-secondary" data-bs-dismiss="modal">Close
                            </button>

                        </div>
                        <div className="modal-body">
                             <InventoryTransferDetail transaction_id={this.state.transactionId} renderAs={"inline"} transaction_id={this.state.transactionId} renderAs={"inline"} inventoryId={this.state.transactionId}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
 

    
    render                                  =   ()  =>  {
        return (<ApplicationLayout>
         <Helmet><title>ItemWise Inventory Transfer - Report</title></Helmet>
            {this.pageTitleBarJsx()}
            <div className="container-fluid pl5">
                <div className="page_containt row">
                    <div id="pageTbl" className="pageTbl col-12 pb-2">
                        {this.state.formDataLoaded
                            ? (<Ax>
                                {this.reportFilterFormJsx()}
                                 <div ref={this.criteriaRef}
                                    style={{
                                        position: 'sticky',
                                        top: 0,
                                        background: 'white',
                                    }}>
                                <DisplaySearchCriteria searchedElems={this.state.formSearchedElems} />
                                </div>
                                {this.reportListingDisplayJsx()}
                            </Ax>)
                            : <Loader />
                        }
                         {this.state.listingMeta 
                            ? <DisplayListPagination meta={this.state.listingMeta} onPageChange={(e) => this.loadListingTblData(e.selected + 1)} />
                            : null
                        }
                    </div>
                </div>
            </div>
            {this.transactionDetailsModalJsx()}
           
        </ApplicationLayout>);
    }
     
     
}

const mapStateToProps = state => {
    return {
        access_token            :   state.auth.access_token,
        all_warehouses          :   state.app && state.app.warehouses ? state.app.warehouses : [],
        all_periods             :   state.app && state.app.periods ? state.app.periods : [],
        item_tags               :   state.app && state.app.item_tags ? state.app.item_tags : [],
        report_listing          :   state.app && state.app.report_listing && state.app.report_listing.length > 0 ? state.app.report_listing : []
    };
};

export default connect(mapStateToProps)(ItemWiseInventoryTransfer);